import clsx from 'clsx';
import * as React from 'react';
import useDraft from '../hooks/useDraft';
import useKites from '../hooks/useKites';
import DeleteIcon from '../icons/DeleteIcon';

export default function KiteList() {
    const { kites, select, remove } = useKites();
    const {
        draft: { name: draftName, id: draftId },
    } = useDraft();

    function handleSelect(name) {
        select(name);
    }

    function handleDelete(name) {
        remove(name);
    }

    return Object.keys(kites).length ? (
        <div className="dialog kite-chooser" key={draftName}>
            <ul className="dialog__list">
                {Object.values(kites)
                    // .sort((a,b) => a.name > b.name ? 1 : -1)
                    .map((kite) => (
                        <li
                            key={kite.id}
                            className={clsx('dialog__list__item', {
                                'is-selected': kite.id === draftId,
                            })}
                            onClick={
                                kite.id !== draftId
                                    ? () => handleSelect(kite.id)
                                    : undefined
                            }
                        >
                            {kite.name}
                            <button
                                className="dialog__button button--icon"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleDelete(kite.id || kite.name);
                                }}
                            >
                                <DeleteIcon />
                            </button>
                        </li>
                    ))}
            </ul>
        </div>
    ) : (
        <div className="dialog">you have no kites yet</div>
    );
}
